export const DELAY_TRICK_ENDED = 2 * 1000;

export const TWEEN_DURATION = 400;

export const TWEEN_EASING = 'Expo.Out';

export const DEFAULT_EVENT_DELAY = 200;

/** Maximum device-pixel-ratio we render at. Capping avoids melting GPUs on 3x phones
 *  (important for the Capacitor-wrapped native builds) while staying far sharper than 1x. */
export const MAX_RENDER_DPR = 2;

/** Rendering resolution used for the Phaser game config and all Text objects.
 *  Matches physical pixels (capped) so text and sprites stay crisp on HiDPI displays
 *  and inside the Capacitor WebView. */
export function getResolution(): number {
	return Math.min(window.devicePixelRatio || 1, MAX_RENDER_DPR);
}
